const FACEBOOK_EVENT_PATH = /(?:^|\/)events\/(\d+)(?:\/|$)/i;

function facebookEventId(event) {
  const value = event?.links?.facebook;
  if (typeof value !== "string") return "";

  try {
    const url = new URL(value, "https://www.facebook.com");
    if (!/(^|\.)facebook\.com$/i.test(url.hostname)) return "";
    return url.pathname.match(FACEBOOK_EVENT_PATH)?.[1] ?? "";
  } catch {
    return "";
  }
}

function eventIdentity(event) {
  const facebookId = facebookEventId(event);
  if (!facebookId) return event?.id ? `record:${event.id}` : null;

  // Facebook recurring events share a parent ID, so the start time keeps
  // separate occurrences while collapsing parent/occurrence URL variants.
  return `facebook:${facebookId}:${event?.startAt ?? ""}`;
}

function facebookPathDepth(event) {
  const value = event?.links?.facebook;
  if (typeof value !== "string") return Number.MAX_SAFE_INTEGER;
  try {
    return new URL(value, "https://www.facebook.com").pathname.split("/").filter(Boolean).length;
  } catch {
    return Number.MAX_SAFE_INTEGER;
  }
}

export function uniqueEvents(events = []) {
  const unique = [];
  const positions = new Map();

  events.forEach((event) => {
    const identity = eventIdentity(event);
    if (!identity) {
      unique.push(event);
      return;
    }
    const position = positions.get(identity);
    if (position === undefined) {
      positions.set(identity, unique.length);
      unique.push(event);
      return;
    }

    // Prefer the canonical /events/{id} record when it arrives after a
    // nested Facebook occurrence URL.
    if (facebookPathDepth(event) < facebookPathDepth(unique[position])) {
      unique[position] = event;
    }
  });

  return unique;
}
